/**
 * ObjectTypeMenu React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import connect from "react-redux/es/connect/connect";
import PropTypes from 'prop-types';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import {selectTypeCreatable} from "../../redux/authorization/selectors";


/**
 * ObjectTypeMenu shows a menu with object types including user authorization
 * @author Jens Gruschel
 */
export class ObjectTypeMenu extends React.Component {

    state = {
        anchor: null
    };
    
    open = (anchor) => {
        this.setState({anchor: anchor || this.props.anchor});
    }

    close = () => {
        this.setState({anchor: null});
    }

    render() {

        // const {classes} = this.props;

        return (
            <Menu
                anchorEl={this.state.anchor}
                open={!!this.state.anchor}
                onClose={event => {this.setState({anchor: null});}}
            >
                {this.props.types.filter(
                    typeId => selectTypeCreatable(this.props.authorization, typeId)
                ).map(
                    typeId => {
                        const typeDefinition = this.props.typeDefinitions[typeId];
                        const typeName = typeDefinition ? typeDefinition.title : undefined;
                        const iconUrl = typeDefinition && typeDefinition.fields ? typeDefinition.fields.iconurl : undefined;
                        return <MenuItem
                            key={typeId}
                            onClick={event => {
                                this.setState({anchor: null});
                                this.props.onSelect(typeId);
                            }}
                        >
                            <ListItemIcon>
                                <img src={iconUrl} alt=" " width={24} height={24} style={{opacity: 0.53}}/>
                            </ListItemIcon>
                            <ListItemText inset primary={typeName || typeId} />
                        </MenuItem>
                    }
                )}
            </Menu>
        );
    }
}

const mapStateToProps = state => {
    return {
        authorization: state.authorization,
        typeDefinitions: state.types.typeDefinitions,
    }
};

ObjectTypeMenu.propTypes = {
    types: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(ObjectTypeMenu);
